import loglevel from "loglevel";
import LogRocket from "logrocket";

const log = loglevel.getLogger("LogRocketUtils");

export const logRocketIdentify = (
  userId: string,
  email: string,
  firstName: string,
  lastName: string,
) => {
  try {
    LogRocket.identify(userId, {
      email,
      first_name: firstName,
      last_name: lastName,
    });
  } catch (e) {
    log.error("Error identifying user", e);
  }
};
